<template>
  <div>
    <b-card>
    <b-row>
      <b-col cols="12" lg="1" class="d-flex align-items-center mb-1">
        <b-dropdown
          variant="flat-secondary"
          class="avenir-medium mr-1 show-dropdown-views"
        >
          <template #button-content>
            <b-icon :icon="view_list ?'list-ol' : 'grid-fill'" font-scale="1.5" variant="dark" />
          </template>

          <b-dropdown-item @click="view_list = true">
            <b-icon icon="list-ol" font-scale="1" variant="dark" class="mr-05"/>
            {{$t('campaigns.viewList')}}
          </b-dropdown-item>
          <b-dropdown-item @click="view_list = false">
            <b-icon icon="grid-fill" font-scale="1" variant="dark" class="mr-05"/>
            {{$t('campaigns.viewCard')}}
          </b-dropdown-item>
        </b-dropdown>
      <b-button-group class="body-button-center hide-dropdown-views">
        <b-button 
          :class="view_list ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'" 
          :variant="view_list ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'" 
          @click="view_list = false; current_page = 1"
        >
          <b-icon icon="grid-fill" font-scale="1.5" variant="dark"></b-icon>
        </b-button>
        <b-button 
          :class="view_list ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
          :variant="view_list ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
          @click="view_list = true; current_page = 1"
        >
          <b-icon icon="list-ol" font-scale="1.5" variant="dark"></b-icon>
        </b-button>
      </b-button-group>
    </b-col>

    <b-col cols="12" lg="11" class="mb-1">
      <filters-dropdown
        :networks_avaibles="networks_avaibles"
        :actions_options="actions_options"
        :view_actions="true"
        @filters-changed="onFiltersChanged"
        @action-selected="onActionSelected"
      />      
    </b-col>

      <b-col>
        <div class="my-1 d-flex" v-if="(!view_list && checkedNames.length > 0) || (view_list && exportable.length > 0)">
          <span>{{$t('creator.selected_influencers_check')}}: {{ !view_list ? checkedNames.length : exportable.length }}</span>
        </div>
      </b-col>  
      <div class="w-100" :key="change_influencers" v-if="!view_list && total_results >= 1">
          <b-row class="w-100 m-0" v-if="rows.length > 0" :key="change_influencers">
            <b-col v-for="(influencer, index) in rows" :key="index" class=" col-12 col-sm-6 col-lg-4 col-xl-3">
              <b-card
                class="text-center card-all-users-profiles"
                style="box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important"
                footer-class="without-border"
                :ref="`card-influencer-${influencer.uuid}`"
              >
                <div class="mb-1 position-relative">
                  <b-form-checkbox
                    v-model="checkedNames"
                    :value="influencer.uuid"
                    class="custom-control-primary"
                    :disabled="disabledUpdateCampaign()"
                  />
                  <div class="delete-creator p-0">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none p-0"
                      no-caret
                      dropright
                    >
                      <template v-slot:button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-body align-middle mr-25"
                        />
                      </template>
                      <b-dropdown-item @click="openNotes(influencer.uuid, influencer.name)">
                        <feather-icon icon="FileTextIcon" class="mr-50" />
                        <span>{{ $t('campaigns.notes') }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item :disabled="disabledUpdateCampaign()" @click="copyLink(influencer)">
                        <feather-icon icon="LinkIcon" class="mr-50" />
                        <span>{{$t('campaigns.copy_link')}}</span>
                      </b-dropdown-item>
                      <b-dropdown-item :disabled="disabledUpdateCampaign()" @click="deleteCreator(influencer.uuid)">
                        <feather-icon icon="XCircleIcon" class="mr-50" />
                        <span>{{$t('campaigns.delete_creator')}}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="profile-image-wrapper mb-2">
                  <div class="profile-image p-0 position-relative">
                      <b-avatar class="socialnet-campaigns p-0" variant="light">
                        <b-img  :src="`${getIconWhite(influencer.network)}`" :class="getIconColor(influencer.network)" fluid></b-img>
                      </b-avatar>
                    <b-avatar
                      size="200"
                      variant="light-secondary"
                      :src="influencer.avatar"
                    >
                     
                    </b-avatar>
                  </div>
                </div>
                <b-link @click="openSummaryProfile(influencer)">
                  <h3>
                    {{ influencer.name }}
                    <image-verified v-if="influencer.is_verified" class="square-20"/>
                  </h3>
                  <h5 class="text-blue font-weight-bolder">
                    @{{ getUsername(influencer)}}
                  </h5>
                </b-link>
                <h5 class="text-muted font-weight-bolder">
                  {{ $t(`influencerCategory.${influencer.type_influencer}`)}}
                </h5>

                <div class="d-flex justify-content-center align-items-center flex-wrap mt-3">
                  <div v-if="influencer.followers > 0" class="mb-1 col-12 col-md-6">
                    <h6 class="text-muted font-weight-bolder">
                      {{ $t('campaigns.followers') }}
                    </h6>
                    <h3 class="mb-0">
                      {{ engagement(influencer.followers) }}
                    </h3>
                  </div>
                  <div class="mb-1 col-12 col-md-6">
                    <h6 class="text-muted font-weight-bolder">
                      {{$t('campaigns.published_contents')}}
                    </h6>
                    <h3 class="mb-0">
                      {{ influencer.published_contents }}
                    </h3>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="mb-1 col-12">
                    <b-button class="blue-button" variant="blue-button" @click="addContent(influencer)" :disabled="disabledUpdateCampaign()">{{$t('campaigns.detailsCreator')}}</b-button>
                  </div>
                  <div class="mb-1 col-12" v-if="influencer.can_complete">
                    <b-button
                      variant="success"
                      @click="confirmCompleteDeal(influencer.uuid)"
                      :disabled="loading_deal_uuids.includes(influencer.uuid)"
                    >
                      <feather-icon icon="CheckCircleIcon" class="mr-50"/>
                      {{ $t('campaigns.complete_deal') }}
                    </b-button>
                  </div>
                </div>

 
              </b-card>
            </b-col>
            <div class="col-12 row m-0 p-0" v-if="loading_creators">
              <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 4" :key="i">
                <b-card class="card-skeleton">
                  <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
                  <b-skeleton class="skeleton h1 col-10"></b-skeleton>
                  <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>

                  <b-skeleton class="skeleton col-4"></b-skeleton>
                  <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>

                  <div class="d-flex w-100 mb-1">
                    <b-skeleton type="button" class="skeleton w-100 mr-2"></b-skeleton>
                    <b-skeleton type="button" class="skeleton w-100 ml-2"></b-skeleton>

                  </div>
                </b-card>
              </b-col>
            </div>
            <b-col class="col-12 text-center all-results-loaded-text" v-if="!loading_creators && rows.length > 0 && rows.length >= total_results">
              <feather-icon icon="CheckIcon" size="16" class="mr-50"/>
              <span>{{ $t('campaigns.allResultsLoaded') }}</span>
            </b-col>
            </b-row>
      </div>
      <b-col class="col-12" v-if="view_list && total_results >= 1">
        <div class="position-relative overflow-scroll">
        <b-card id="container-table">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :row-style-class="getRowClass"
            :sort-options="{
              enabled: true,
              initialSortBy: {field: 'type_influencer', type: 'asc'},
              multipleColumns: false,
            }"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: false,
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            :selected-rows.sync="checkedNames"
            @on-selected-rows-change="selectionChanged"
            :class="`${rows.length > 0 ? 'vgt-table-influencers-inner-campaign' : ''} mt-1`"
          >
            <template slot="table-column" slot-scope="props">
              <div v-if="props.column.field === 'name'" class="cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'type_influencer'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'network'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'scope'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
                <div v-if="props.column.field === 'published_contents'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'status'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'status_influencer'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'has_payment_data'" class="d-block text-center cursor-pointer">
                {{ $t(props.column.label) }}
                <b-icon icon="chevron-bar-expand" class="float-right"/>
              </div>
              <div v-if="props.column.field === 'button_add_contente'" class="d-block text-center cursor-pointer">
                ""
              </div>
              <span v-if="props.column.field === 'actions'" class="d-block text-center">
                {{ $t(props.column.label) }}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'name'" class="text-nowrap row-selected-table">
                <b-media vertical-align="center" class="d-flex align-items-center">
                  <template #aside>
                    <div class="container-avatar-table">
                      <b-avatar
                        size="md"
                        :src="props.row.avatar"
                        :text="props.row.username[0]"
                        variant="light-primary"
                      />
                    </div>
                  </template>
                  <b-link @click.stop="openSummaryProfile(props.row)">
                    <span>{{ getUsername(props.row) }}
                    <image-verified v-if="props.row.is_verified" class="iconCheck"/>
                    </span>
                    </b-link>
                </b-media>
              </span>
              <span
                v-else-if="props.column.field === 'type_influencer'"
                class="text-nowrap d-block text-center p-2"
              >
                <span class="text-nowrap">{{ $t(getTypeInfluencerTraduction(props.row.type_influencer)) }}</span>
              </span>
              <span
                v-else-if="props.column.field === 'network'"
                class="text-nowrap d-block text-center"
              >
                <div class="d-flex align-items-center w-avatares-table">
                  <b-avatar-group
                    v-if="props.row.contents_by_type && props.row.contents_by_type.length > 0"
                    size="20"
                    :overlap="props.row.contents_by_type.length === 1 ? '0' : '0.3'"
                  >
                    <b-avatar
                      v-for="(content, index) in props.row.contents_by_type.slice(0, 3)"
                      :key="index"
                    >
                      <b-img
                        :id="`contents-type-${props.index}-${index}`"
                        :src="getIconWhite(content.network)"
                        :class="getIconColor(content.network, false)"
                        fluid
                      />
                      <b-tooltip :target="`contents-type-${props.index}-${index}`">
                        <span>{{getLabelContentType(content)}}</span>        
                      </b-tooltip>
                    </b-avatar>
                    <b-avatar
                      class="avatar-contents-more"
                      v-if="props.row.contents_by_type.length > 3"
                    >
                      +{{ props.row.contents_by_type.length - 3 }}
                    </b-avatar>
                  </b-avatar-group>
                  <a
                    v-else
                    class="text-nowrap name-link"
                    :href="getURL(props.row.network, props.row.username, props.row.network === 'youtube')"
                    target="_blank"
                  >
                    <b-avatar variant="light" size="20">
                      <b-img
                        class="icon-squad-network"
                        :src="getIconWhite(props.row.network)"
                        :class="getIconColor(props.row.network, false)"
                        fluid
                      />
                    </b-avatar>
                    {{ capitalize(props.row.network) }}
                  </a>
                </div>
              </span>
              <span
                v-else-if="props.column.field === 'scope'"
                class="text-nowrap d-block text-center"
              >
                <span class="text-nowrap">{{ getFormat(props.row.scope) }}</span>
              </span>
              <span
                v-else-if="props.column.field === 'published_contents'"
                class="text-nowrap text-center d-block"
              >
                <span class="text-nowrap">{{ props.row.published_contents }}</span>
              </span>
              <span v-else-if="props.column.field === 'status'" class="d-block text-center">
                <b-badge :variant="statusVariant(props.row.status)">
                  {{ $t(getStatus(props.row.status)) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'status_influencer'" class="d-block text-center">
                <b-badge :variant="statusVariant(props.row.status_influencer)">
                  {{ $t(getStatus(props.row.status_influencer)) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'has_payment_data'" class="d-block text-center">
                <b-badge :variant="statusVariantPaymentData(props.row.has_payment_data)">
                  {{props.row.has_payment_data ? $t('campaigns.yes') : 'No'}}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'button_add'" class="d-flex justify-content-center">
                <b-button size="sm" @click="addContent(props.row)" variant="blue-button" class="float-right mb-1 blue-button">
                  {{$t('campaigns.detailsCreator')}}
                  <feather-icon
                    icon="PlusCircleIcon"
                    size="16"
                  />
                </b-button>
              </span>
              <!-- Column: Action -->
              <span v-else-if="props.column.field === 'actions'" class="d-block text-center">
                <span>
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    dropright
                  >
                    <template v-slot:button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="text-body align-middle mr-25"
                      />
                    </template>
                    <b-dropdown-item @click="copyLink(props.row)">
                      <feather-icon icon="LinkIcon" class="mr-50" />
                      <span>{{$t('campaigns.copy_link')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="openNotes(props.row.uuid, props.row.username)">
                      <feather-icon icon="FileTextIcon" class="mr-50" />
                      <span>{{$t('campaigns.notes')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="addContent(props.row)">
                      <feather-icon icon="PlusCircleIcon" class="mr-50" />
                      <span>{{$t('campaigns.extra_content')}}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="props.row.can_complete" @click="confirmCompleteDeal(props.row.uuid)">
                      <feather-icon icon="CheckCircleIcon" class="mr-50" />
                      <span>{{ $t('campaigns.complete_deal') }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="deleteCreator(props.row.uuid)">
                      <feather-icon icon="XCircleIcon" class="mr-50" />
                      <span>{{$t('campaigns.delete_creator')}}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
            </template>

          </vue-good-table>
        </b-card>
      </div>
      </b-col>
      <b-col class="col-12" v-if="total_results === 0">
        <no-Results
          :title= "$t('creator.noResultsSearch')"
          :show_button="false"
        />
      </b-col>
      <b-col v-if="view_list && total_results >= 1" class="d-flex align-items-center justify-content-between flex-wrap">
        <b-dropdown
          variant="flat-secondary"
          class="page-size-dropdown"
          :text="`${$t('campaigns.resultsPerPage')}: ${per_page}`"
        >
          <b-dropdown-item
            v-for="size in page_size_options"
            :key="size"
            @click="updatePerPage(size)"
          >
            {{ size }}
          </b-dropdown-item>
        </b-dropdown>
        <pagination-brandme-v2
          :total_rows="total_results"
          :current_page="current_page"
          :per_page="per_page"
          @update_current_page="updateCurrentPage"
        ></pagination-brandme-v2>
      </b-col>

    </b-row>

    <form-add-content :show_form_metrics="false" @contentAdded="contentAdded" :campaign_influencer="campaign_influencer_to_add" :show_add_content="show_add_content" :content_published="content_published" @update_header="update_header" :key="key_modal_add" :agreement_with_creator="agreement_with_creator" :content_by_network="content_by_network"/>

    <b-sidebar
      right
      shadow
      v-model="show_side"
    >
      <div class="px-3">
        <div class="d-flex justify-content-between mb-2">
          <b-media vertical-align="center" class="d-flex justify-content-center align-items-center flex-wrap mb-1 col-6">
            <template #aside>
              <div class="container-avatar-table col-12">
                <b-avatar
                  size="lg"
                  :src="creator.avatar"
                  :text="creator.username"
                  variant="light-primary"
                />
                <b-avatar class="container-avatar-table-icon sidebar-icon">
                  <b-img
                    :src="`${getIconWhite(creator.network)}`" :class="getIconColor(creator.network)" fluid></b-img>
                </b-avatar>
              </div>
            </template>

            <div class="col-12">
              <a class="d-block font-weight-bold h4 mb-0 col-12 text-center"
                  :href="getURL(creator.network, creator.username, (creator.network === 'youtube') ? true : false)"
                  target="_blank"
              >
                  {{ getUsername(creator) }}
              </a>
            </div>

          </b-media>  
          <b-col class="d-flex flex-wrap justify-content-center col-6 mb-2 mt-1">
            <b-avatar rounded="lg" :variant="statusVariant(creator.status)">
              <feather-icon
                size="18"
                icon="LikeIcon"
              />
            </b-avatar>    
            <span class="d-block h5 col-12 text-center mt-1">{{$t(`campaigns.${creator.status}`)}}</span>
            <span class="text-muted d-block col-12 text-center">{{$t('campaigns.status')}}</span>
          </b-col>
        </div>

        <b-row>
          <b-col class="col-6">
            <span class="d-block h5 col-12 text-center">{{getTypeInfluencer(creator.type_influencer)}}</span>
            <span class="text-muted d-block col-12 text-center">{{$t('campaigns.type_influencer')}}</span>
          </b-col>
          
          <b-col class="col-6">
            <span class="d-block h5 col-12 text-center">{{creator.published_contents}}</span>
            <span class="text-muted d-block col-12 text-center">{{$t('campaigns.published_contents')}}</span>
          </b-col>

          <b-col class="col-6 mt-2">
            <span class="d-block h5 col-12 text-center">{{$t('generalLeads.date')}}</span>
            <span class="text-muted d-block col-12 text-center">{{shortDate(creator.date)}}</span>
          </b-col>
        </b-row>
        <hr />
        <b-button id="tooltip-extra-content" variant="flat-primary" class="btn-icon rounded-circle add-content-sidebar-button" @click="addContent(creator)">
          <feather-icon icon="PlusCircleIcon" size="20" class=""/>
        </b-button>
        <b-tooltip target="tooltip-extra-content">
          <span>{{$t('campaigns.extra_content')}}</span>        
        </b-tooltip>

        <h5 class="text-center">{{$t('campaigns.edit_creator')}}</h5>
        <validation-observer #default="{ invalid }">
          <b-row class="w-100 mt-2">
            <b-col cols="12">
              <b-row>
                
                <b-col :class="`col-12 mb-1`">
                  <validation-provider rules="required">
                    <b-form-group 
                      :label="$t('campaigns.estimated_cost')"
                      :description="''"
                    >
                      <b-input-group class="m-auto">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="DollarSignIcon" />
                        </b-input-group-prepend>
                        <input-number-comma :price="creator.estimated_cost" identifier="estimated_cost" :key="change_sidebar" @changeValue="changeValue" :placeholder="$t('campaigns.estimated_cost')"></input-number-comma>
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col :class="`col-12 mb-1`">
                  <validation-provider rules="required">
                    <b-form-group
                      :label="$t('campaigns.agreed_cost')"
                      :description="''"                    
                    >
                      <b-input-group class="m-auto">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="DollarSignIcon" />
                        </b-input-group-prepend>
                        <input-number-comma :price="creator.agreed_cost" identifier="agreed_cost" :key="change_sidebar" @changeValue="changeValue" :placeholder="$t('campaigns.agreed_cost')"></input-number-comma>
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col :class="`col-12 mb-1`">
                  <validation-provider rules="required">
                    <b-form-group
                      :label="$t('scope_number')"
                      :description="''"                    
                    >
                      <b-input-group class="m-auto">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="ActivityIcon" />
                        </b-input-group-prepend>
                        <input-number-comma :price="creator.scope" identifier="scope" :key="change_sidebar" @changeValue="changeValue" :placeholder="$t('scope_number')"></input-number-comma>
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
          <b-row class="d-flex justify-content-center mt-1">
            <b-button
              variant="success success-button-invitations"
              class="success-button-invitations"
              @click="updateCreator(creator.uuid)"
              :disabled="invalid"
            >
              {{$t('dashboard.save')}}
            </b-button>
          </b-row>
        </validation-observer>

      </div>
    </b-sidebar>
    <modal-brandme
      :show_modal="modal_complete_deal"
      size="md"
      @hidden="modal_complete_deal = false"
      bg_title="complete-deal-modal-header"
      closeIcon="complete-deal-close-icon"
      :key="`modal-complete-deal-${change_modal_complete_deal}`"
    >
      <template #title>
        <h5 class="m-0 text-white">
          <feather-icon icon="AlertTriangleIcon" class="mr-50" size="20"/>
          {{ $t('campaigns.complete_deal_confirm_title') }}
        </h5>
      </template>
      <template #body>
        <div class="complete-deal-warning-box mb-1">
          <strong>{{ $t('campaigns.complete_deal_confirm_irreversible') }}</strong>
        </div>
        <p class="mb-1">{{ $t('campaigns.complete_deal_confirm_body') }}</p>
        <p class="complete-deal-info-text">
          <feather-icon icon="InfoIcon" class="mr-50" size="14"/>
          {{ $t('campaigns.complete_deal_confirm_note') }}
        </p>
      </template>
      <template #footer>
        <div class="d-flex justify-content-end w-100 p-1">
          <b-button variant="secondary" class="mr-1" @click="modal_complete_deal = false; change_modal_complete_deal += 1;">
            <feather-icon icon="XIcon" class="mr-50"/>
            {{ $t('campaigns.msjCancel') }}
          </b-button>
          <b-button
            variant="success"
            :disabled="loading_deal_uuids.includes(pending_complete_deal_uuid)"
            @click="completeDeal(pending_complete_deal_uuid)"
          >
            <feather-icon icon="CheckCircleIcon" class="mr-50"/>
            {{ $t('campaigns.complete_deal_confirm_btn') }}
          </b-button>
        </div>
      </template>
    </modal-brandme>

    <modal-brandme
      :show_modal="modal_notes"
      :no_footer="true"
      size="md"
      @hidden="modal_notes = false"
      :key="`modal-notes-${update_modal_notes}`"
    >
      <template #title>
        <h5 class="m-0">
          {{ $t('campaigns.notes') }}
          <span v-if="notes_influencer_name"> de {{ notes_influencer_name }}</span>
        </h5>
      </template>
      <template #body>
        <notes-modal
          :notes="notes_influencer"
          :total_count="notes_total_count"
          :current_page="notes_current_page"
          :page_size="5"
          @add_note="onAddNote"
          @edit_note="onEditNote"
          @delete_note="onDeleteNote"
          @change_page="onNotesPageChange"
        />
      </template>
    </modal-brandme>
    </b-card>
    <sidebar-search-new
      :open_sidebar="open_sidebar" 
      :key="update_sidebar" 
      :username="data_sidebar"
      :network="select_network"
      class="open-sidebar-search"
      v-if="open_sidebar"
    >
    </sidebar-search-new>
  </div>
</template>

<script>

import {
  BLink,
  BFormCheckbox,
  BButtonGroup,
  BImg,
  BCard,
  BRow,
  BCol,
  BAvatar,
  BAvatarGroup,
  BBadge,
  BDropdown,
  BDropdownItem,
  BSidebar,
  BMedia,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  BFormGroup,
  BTooltip,
  BSkeleton,
} from "bootstrap-vue";
import service from "@/services/campaign";
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import { VueGoodTable } from "vue-good-table";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import manage_campaign from '@/services/manage_campaign';
import FormAddContent from "./FormAddContent.vue";
import inputNumberComma from "../inputs/inputNumberComma.vue";
import ImageVerified from '@/views/components/image/ImageVerified.vue';
import { getIconWhite, getIconColor } from '@/libs/utils/icons';
import { getUserData, hasPermission } from '@/libs/utils/user';
import { getTypeInfluencerTraduction, getTypeInfluencer, getMotivationalPhrase, getTypeInfluencerNumber, getImageInfluencer } from '@/libs/utils/others';
import { getURL } from '@/libs/utils/urls'
import { capitalize, getFormat, decimalFixed } from '@/libs/utils/formats';
import { statusVariant, getStatus, statusVariantPaymentData } from '@/libs/utils/series_graphs';

export default {
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  components: {
    BSkeleton,
    ImageVerified,
    BImg,
    VueGoodTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BCard,
    BRow,
    BCol,
    BAvatar,
    BAvatarGroup,
    BSidebar,
    BMedia,
    BInputGroup,
    BInputGroupPrepend,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BFormGroup,
    FormAddContent,
    inputNumberComma,
    BTooltip,
    BLink,
    BFormCheckbox,
    BButtonGroup,
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    NotesModal: () => import('@/views/components/campaign/NotesModal.vue'),
    filtersDropdown: () => import('@/views/components/brandme-ai/dropdowns/filtersDropdown.vue'),
    SidebarSearchNew: () => import('@/views/buscador/SidebarSearchNew.vue'),
    noResults: () => import('@/views/pages/proposals/stepper/noResults.vue'),
    paginationBrandmeV2: () => import('@/views/components/pagination/paginationBrandmeV2.vue')
  },
  data() {
    return {
      query: '',
      filter_category: '',
      filter_networks: [],
      filters_params: '',
      networks_avaibles: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'youtube', text: 'YouTube' },
        { value: 'tiktok', text: 'TikTok' },
        { value: 'twitter', text: 'Twitter' },
        { value: 'twitch', text: 'Twitch' }
      ],
      decimalFixed,
      checkedNames: [],
      change_influencers: 0,
      open_sidebar: false,
      update_sidebar: false,
      data_sidebar: '',
      select_network: 'instagram',
      view_list: false,
      hasPermission,
      getImageInfluencer,
      getTypeInfluencerNumber,
      getMotivationalPhrase,
      getTypeInfluencer,
      statusVariantPaymentData,
      getStatus,
      getIconColor,
      getIconWhite,
      statusVariant,
      getFormat,
      capitalize,
      getURL,
      getTypeInfluencerTraduction,
      getUserData,
      content_published: false,
      creator: {},
      show_side: false,
      local: window.location.origin,
      per_page: 50,
      page_size_options: [10, 25, 50, 100],
      current_page: 1,
      total_results: 0,
      dir: false,
      columns: [
        {
          label: "lists.influencer",
          field: "name",
        },
        {
          label: "campaigns.type_influencer",
          field: "type_influencer",
          sortable: true,
          sortFn: this.sortFn,
        },
        {
          label: "settings.social.network",
          field: "network",
        },
        {
          label: "campaigns.followers",
          field: "scope",
          type: 'number'
        },
        {
          label: "campaigns.published_contents",
          field: "published_contents",
        },
        {
          label: "campaigns.status",
          field: "status",
        },
        {
          label: "campaigns.status_influencer",
          field: "status_influencer",
        },
        {
          label: "campaigns.has_payment_data",
          field: "has_payment_data",
        },
        {
          label: "button_add_contente",
          field: "button_add",
        },
        {
          label: "campaigns.actions",
          field: "actions",
        },
      ],
      rows: [],
      info: [],
      exportable: [],
      show_add_content: false,
      key_modal_add: false,
      campaign_influencer_to_add: '',
      agreement_with_creator: '',
      change_sidebar: false,
      interval_loading: null,
      has_next_influencers: false,
      loading_creators: false,
      content_by_network: {},
      modal_notes: false,
      notes_influencer: [],
      notes_influencer_name: '',
      notes_influencer_uuid: null,
      notes_current_page: 1,
      notes_total_count: 0,
      update_modal_notes: 1,
      loading_deal_uuids: [],
      modal_complete_deal: false,
      pending_complete_deal_uuid: null,
      change_modal_complete_deal: 0
    };
  },
  created() {
    this.$vs.loading({
      type: 'sound',
      background: 'rgba(255, 255, 255, 1)',
      text: getMotivationalPhrase(),
    });

    this.interval_loading = setInterval(() => {
      const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

      if (prev_loading) {
        prev_loading.classList.add('fade-out');
        setTimeout(function() {
          prev_loading.remove()
        }, 500);

        this.$vs.loading({
          type: 'sound',
          background: 'rgba(255, 255, 255, 1)',
          text: getMotivationalPhrase(),
        });
      }
    }, 5000);

    this.getCampaignManage()
  },
  computed: {
    actions_options() {
      return [
        {
          value: 'select_all',
          text: 'actionSelectAll',
          icon: 'CheckSquareIcon',
          disabled: this.disabledUpdateCampaign(),
          view_drop_item: true,
        },
        {
          value: 'unselect_all',
          text: 'actionRemoveSelection',
          icon: 'XSquareIcon',
          disabled: this.disabledUpdateCampaign(),
          view_drop_item: true,
        },
        {
          value: 'exportSummary',
          text: 'exportSummary',
          icon: 'ShareIcon',
          disabled: this.disabledUpdateCampaign() || !this.hasSelectedInfluencers(),
          view_drop_item: true,
        },
        {
          value: 'downloadPaymentInfo',
          text: 'downloadPaymentInfo',
          icon: 'DollarSignIcon',
          disabled: !this.hasSelectedInfluencers(),
          view_drop_item: getUserData().is_superuser,
        },
        {
          value: 'export',
          text: 'export',
          icon: 'ShareIcon',
          disabled: !this.hasSelectedInfluencers(),
          view_drop_item: true,
        },
        {
          value: 'delete',
          text: 'deleteBtn',
          icon: 'UserMinusIcon',
          disabled: this.disabledUpdateCampaign() || !this.hasSelectedInfluencers(),
          view_drop_item: true,
        },
      ];
    }
  },
  methods: {
    updateCurrentPage(page) {
      this.current_page = page;
    },
    updatePerPage(size) {
      if (this.per_page === size) return;

      this.per_page = size;
      if (this.current_page === 1) {
        this.getCampaignManage();
      } else {
        this.current_page = 1;
      }
    },
    openNotes(influencer_uuid, name) {
      this.notes_influencer_uuid = influencer_uuid;
      this.notes_current_page = 1;
      service.getNotesInfluencerCampaign(influencer_uuid, 1, 5).then(response => {
        this.notes_influencer = response.results || [];
        this.notes_total_count = response.count || 0;
        this.notes_influencer_name = name || '';
        this.modal_notes = true;
        this.update_modal_notes = this.update_modal_notes + 1;
      });
    },
    onNotesPageChange(page) {
      this.notes_current_page = page;
      service.getNotesInfluencerCampaign(this.notes_influencer_uuid, page, 5).then(response => {
        this.notes_influencer = response.results || [];
        this.notes_total_count = response.count || 0;
      });
    },
    onAddNote(note_text) {
      service.addCampaignInfluencerNote(this.notes_influencer_uuid, note_text)
        .then((response) => {
          this.notes_influencer.unshift(response);
          this.notes_total_count += 1;
        })
        .catch(() => this.$swal({ title: this.$t('campaigns.errormessage'), icon: 'warning', customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false, heightAuto: false }))
    },
    onEditNote({ uuid, note }) {
      service.updateCampaignInfluencerNote(uuid, note)
        .then((response) => {
          const idx = this.notes_influencer.findIndex(n => n.uuid === uuid);
          if (idx !== -1) this.$set(this.notes_influencer, idx, response);
        })
        .catch(() => this.$swal({ title: this.$t('campaigns.errormessage'), icon: 'warning', customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false, heightAuto: false }))
    },
    onDeleteNote(uuid) {
      service.deleteCampaignInfluencerNote(uuid)
        .then(() => {
          this.notes_influencer = this.notes_influencer.filter(n => n.uuid !== uuid);
          this.notes_total_count -= 1;
        })
        .catch(() => this.$swal({ title: this.$t('campaigns.errormessage'), icon: 'warning', customClass: { confirmButton: 'btn btn-danger' }, buttonsStyling: false, heightAuto: false }))
    },
    onActionSelected(action) {
      const action_on = {
        select_all: this.selectAll,
        unselect_all: this.unselectAll,
        exportSummary: this.exportCampaignSummaries,
        downloadPaymentInfo: this.exportPaymentData,
        export: this.exportSelected,
        delete: this.bulkRemove,
      };

      if (action_on[action]) action_on[action]();
    },
    onFiltersChanged({ query, type, networks }) {
      this.query = query;
      this.filter_category = type === 'all' ? '' : type;
      this.filter_networks = networks;

      const params = [];
      if (type && type !== 'all') params.push(`category=${type}`);
      if (networks && networks.length > 0) {
        networks.forEach(net => {
          params.push(`networks=${net}`);
        });
      }

      this.filters_params = params.length ? `&${params.join('&')}` : '';
      this.getCampaignManage();
    },
    getLabelContentType(content) {
      if (content.network === 'tiktok' && content.content_type === 'reel') return this.$t(`invitation.videoVertical`)
      if (content.network === 'blog' && content.content_type === 'post') return 'Blog Post'
      if (content.network === 'snapchat' && content.content_type === 'reel') return 'Spotlight'
      return this.$t(`invitation.${content.content_type}`)
    },
    deletedQuery() {
      this.query = '',
      this.getCampaignManage()
    },
    getRowClass(row) {
      if (this.exportable.some(i => i.uuid === row.uuid)) {
        return 'row-bg-selected';
      }
      return '';
    },

    exportCampaignSummaries() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);

      if (this.view_list) this.checkedNames = this.exportable.map(item => item.uuid);
      const selectedInfluencers = this.rows
        .filter(influencer => this.checkedNames.includes(influencer.uuid))
        .map(influencer => ({
          network: influencer.network,
          username: influencer.username,
        }));

      service.createExportCampaignSummaries(this.$route.params.uuid, selectedInfluencers)
        .then(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: "top-right",
              props: {
                icon: 'LinkIcon',
                title: 'Exportación creada',
                variant: "success",
                text: 'Te avisaremos cuando la exportación esté lista para descargar.',
              }
            })
          })

          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
        .catch(() => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
    },
    getCampaignManage() {
      this.loading_creators = true;
      const page_size = !this.view_list ? 20 : this.per_page;
      service.getCampaignManage(this.$route.params.uuid, this.filters_params, this.query, this.current_page, page_size).then((response) => {
        this.info = response.results;
        this.total_results = response.count;
        this.loading_creators = false;
        this.rows = this.getProperlyRowsTable();
        this.has_next_influencers = response.next !== null;
        this.loading_creators = false
        setTimeout(() => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close();
        }, 500);
      });
    },
    getScrollInfinite() {
      const page_size = 20;
      if ((this.rows.length < this.total_results) || this.rows.length === 0) {
        this.loading_creators = true;
        service.getCampaignManage(this.$route.params.uuid, this.filters_params, this.query, this.current_page, page_size)
          .then(response => {
            this.total_results = response.count;
            this.info = [...this.info, ...response.results];
            this.rows = this.getProperlyRowsTable();
            this.loading_creators = false;
            this.has_next_influencers = response.next !== null;
          });
      }
    },

    engagement (num) {
      let result = ''
      if (num < 1000) {
        result = num
      }
      if (num > 999) {
        result = `${(Math.round(num / 100) / 10)} K`
      }
      if (num > 999999) {
        result = `${(Math.round(num / 100000) / 10)} M`
      }
      if (num > 999999999) {
        result = `${(Math.round(num / 100000000) / 10)} B`
      }
      return result
    },
    openSummaryProfile(item) {
      this.data_sidebar = item.username;
      this.select_network = item.network;
      this.open_sidebar = true;
      this.update_sidebar = !this.update_sidebar;
    },
    selectAll() {
      if (this.disabledUpdateCampaign()) return;
      if (!Array.isArray(this.rows)) return;
      if (this.view_list && (this.exportable.length === 0 || this.exportable.length < this.rows.length)) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "#container-table > div > div > div > div.vgt-responsive > table > thead > tr > th.vgt-checkbox-col > input[type=checkbox]"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();
          }
        });
      } else {
        this.checkedNames = this.rows.map(item => item.uuid);
      }
    },
    unselectAll() {
      if (this.view_list && this.exportable.length > 0) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "#container-table > div > div > div > div.vgt-responsive > table > thead > tr > th.vgt-checkbox-col > input[type=checkbox]"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();
            if (this.exportable.length !== this.rows.length) selectAllCheckbox.click();
          }
        });
      } else {
        this.checkedNames = [];
      }
    },
    getSelectedInfluencers() {
      return this.rows.filter(item => this.checkedNames.includes(item.uuid));
    },

    update_header() {
      this.$emit('update_header');
    },
    sortFn(x, y) {
      const first = getTypeInfluencerNumber(x)
      const second = getTypeInfluencerNumber(y)
      return (first < second ? -1 : (first > second ? 1 : 0));
    },
    bulkRemove() {
      this.$swal({
        title: this.$t('campaigns.textConfirmCreators'),
        text: this.$t('campaigns.textCreators'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirmCreators'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        heightAuto: false,
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          if (this.view_list) this.checkedNames = this.exportable.map(item => item.uuid);
          service.influencerAction(this.$route.params.uuid, this.checkedNames, 'removed').then(() => {
            this.$swal({
              title: this.$t('campaigns.title_deleted_creator'),
              text: this.$t('campaigns.text_deleted_creator'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-success'
              },
              buttonsStyling: false,
              heightAuto: false
            })
            this.update_header();
            this.rows = this.rows.filter((item) => this.checkedNames.indexOf(item.uuid) < 0);
          })
        }
      })
    },
    contentAdded() {
      const uuid = this.campaign_influencer_to_add;
      manage_campaign.getCampaignInfluencerDetail(uuid)
        .then(detail => {
          this.updateRowFromDetail(uuid, detail);
        })
        .catch(() => {
          this.getCampaignManage();
        });
    },
    downloadCsv(rows, name) {
      const csv = rows.map(e => e.join(",")).join("\n")
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", csv]);
      const url = URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.download = name;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    hasSelectedInfluencers() {
      if (this.view_list) {
        return this.exportable.length > 0
      } else {
        return this.checkedNames.length > 0
      }
    },
    exportPaymentData() {
      let data_export = []
      if (this.view_list) {
        data_export = this.exportable
      } else {
        data_export = this.getSelectedInfluencers()
      }
      const rows = [['Influencer', 'Red social', 'Alcance', 'Contenidos publicados', 'Estatus', 'Cuenta Nacional', 'Nombre de beneficiario', 'Banco', 'Cuenta', 'CLABE/ABA/SWIFT/BIC', 'Mail', 'Celular', 'Dirección', 'Ciudad', 'País']];
      data_export.forEach(data => {
        const username = data.network === 'youtube' ? data.name : data.username

        rows.push([
          username,
          capitalize(data.network),
          data.scope,
          data.published_contents,
          this.$t(getStatus(data.status)),
          data.payment_data ? (data.payment_data.is_national ? 'Sí' : 'No') : '-',
          data.payment_data ? data.payment_data.beneficiary_name : '-',
          data.payment_data ? data.payment_data.bank : '-',
          data.payment_data ? `${data.payment_data.account}` : '-',
          data.payment_data ? `${data.payment_data.clabe}` : '-',
          data.payment_data ? data.payment_data.email : '-',
          data.payment_data ? data.payment_data.telephone : '-',
          data.payment_data ? data.payment_data.address : '-',
          data.payment_data ? data.payment_data.city : '-',
          data.payment_data ? data.payment_data.country : '-',
        ])
      })
      this.downloadCsv(rows, "Información de pago.csv")
    },
    exportSelected() {
      let data_export = []
      if (this.view_list) {
        data_export = this.exportable
      } else {
        data_export = this.getSelectedInfluencers()
      }
      const rows = [['Influencer', 'Tipo de influencer', 'Red social', 'Alcance', 'Contenidos publicados', 'Estatus']];

      data_export.forEach(data => {
        const username = data.network === 'youtube' ? data.name : data.username

        rows.push([
          username,
          getTypeInfluencer(data.type_influencer),
          capitalize(data.network),
          data.scope,
          data.published_contents,
          this.$t(getStatus(data.status))
        ])
      })

      this.downloadCsv(rows, "Influencers.csv")
    },
    selectionChanged(data) {
      this.exportable = data.selectedRows;
    },
    onCellClick(data) {
      if (data.column.field !== 'actions') {
        this.show_side = true;
        this.creator = {...data.row};
        this.change_sidebar = !this.change_sidebar
      }
    },
    changeValue(new_value, key) {
      this.creator[key] = new_value
    },
    mapInfluencerItem(item) {
      const content_network = {};
      const contents = [];
      if (Array.isArray(item.content)) {
        item.content.forEach((c) => {
          const network = c.network?.toLowerCase() || '';
          contents.push({ content_type: c.content_type, network: c.network });
          content_network[network] = (content_network[network] || 0) + 1;
        });
      }
      return {
        uuid: item.uuid,
        name: item.influencer.name,
        avatar: getImageInfluencer(item.influencer),
        type_influencer: item.influencer.calculate_category,
        network: item.influencer.network.toLowerCase(),
        channel_id: item.influencer.channel_id,
        followers: item.influencer.followers,
        engagement_rate: item.influencer.engagement_rate,
        scope: item.scope,
        date: item.created_at,
        status: item.status,
        username: item.influencer.username,
        published_contents: this.getContents(item.content),
        agreed_cost: item.agreed_cost,
        estimated_cost: item.estimated_cost,
        is_verified: item.influencer.is_verified,
        payment_data: item.influencer.payment_data,
        has_payment_data: item.influencer.has_payment_data,
        status_influencer: item.status_influencer,
        agreement_with_creator: item.agreement_with_creator,
        content_by_network: content_network,
        contents_by_type: contents,
        can_complete: 'can_complete' in item ? item.can_complete : false,
      };
    },
    updateRowFromDetail(uuid, detail) {
      const idx = this.rows.findIndex(r => r.uuid === uuid);
      if (idx !== -1) this.$set(this.rows, idx, this.mapInfluencerItem(detail));
    },
    getProperlyRowsTable() {
      return this.info.map(item => this.mapInfluencerItem(item));
    },
    shortDate(date) {
      const newDate = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return newDate.toLocaleDateString("es-ES", options);
    },
    getUsername(influencer) {
      if (influencer.network === "youtube") return influencer.name;
      return influencer.username;
    },
    copyLink(data) {
      const url = `${window.location.origin}/external/details/${this.slug}/${data.network}/${data.username}`;
      window.open(url, '_blank');
    },
    deleteCreator(uuid) {
      if (this.disabledUpdateCampaign()) return;

      this.$swal({
        title: this.$t("campaigns.textConfirmCreator"),
        text: this.$t("campaigns.textCreator"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("campaigns.msjConfirmCreator"),
        cancelButtonText: this.$t("campaigns.msjCancel"),
        heightAuto: false,
        customClass: {
          confirmButton: "btn confirm-button",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
         
          const influencer = [];
          influencer.push(uuid);
          const formData = new FormData();
          formData.append("influencers", influencer);
          formData.append("status", "removed");

          service.deleteCreator(this.$route.params.uuid, formData).then(() => {
            this.rows = this.rows.filter((item) => item.uuid !== uuid);
            this.checkedNames = this.checkedNames.filter((id) => id !== uuid);
            this.exportable = this.exportable.filter(row => row.uuid !== uuid)
            this.rows.forEach(info => {
              this.exportable.forEach(exp => {
                if (info.uuid === exp.uuid) {
                  info.vgtSelected = true;
                }
              });
            });
            this.$swal({
              icon: "success",
              title: this.$t('campaigns.deleted_success_title'),
              text: this.$t('campaigns.deleted_success_text'),
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          });
        }
      });
    },
    updateCreator(uuid) {
      this.rows.map((item) => {
        if (item.uuid === uuid) {
          item.estimated_cost = this.creator.estimated_cost;
          item.agreed_cost = this.creator.agreed_cost;
          item.scope = this.creator.scope;
        }
      });
      const form_data = new FormData();
      form_data.append('estimated_cost', this.creator.estimated_cost);
      form_data.append('agreed_cost', this.creator.agreed_cost);
      form_data.append('scope', this.creator.scope);
      
      manage_campaign.updateInfluencer(this.$route.params.uuid, uuid, form_data).then(res => {
        this.$emit('formatHeader', res.campaign_header)
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('campaigns.updated_success'),
              icon: 'ShuffleIcon',
              variant: 'success',
              text: this.$t('campaigns.updated_success_text')
            }
          })
        })
        this.show_side = false;
      });
    },
    getContents(content) {
      let published = 0;
      content.forEach(item => {
        if (item.url_info !== null) {
          published += 1
        } else if (item.image_content !== null) published += 1
      });
      return `${published}/${content.length}`
    },
    disabledUpdateCampaign() {
      return !hasPermission("change_campaign");
    },
    confirmCompleteDeal(uuid) {
      console.log(uuid)
      this.pending_complete_deal_uuid = uuid;
      this.modal_complete_deal = true;
      this.change_modal_complete_deal += 1;
    },
    completeDeal(uuid) {
      this.loading_deal_uuids.push(uuid);
      manage_campaign.completeDeal(uuid)
        .then((response) => {
          this.modal_complete_deal = false;
          this.change_modal_complete_deal += 1;
          const detail = response && response.uuid ? response : (response && response.campaign_influencer ? response.campaign_influencer : null);
          if (detail) {
            this.updateRowFromDetail(uuid, detail);
          } else {
            const idx = this.rows.findIndex(r => r.uuid === uuid);
            if (idx !== -1) this.$set(this.rows[idx], 'can_complete', false);
          }
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.complete_deal_success'),
                icon: 'CheckCircleIcon',
                variant: 'success',
              }
            })
          })
        })
        .catch(() => {
          this.modal_complete_deal = false;
          this.change_modal_complete_deal += 1;
          this.$swal({
            title: this.$t('campaigns.errormessage'),
            icon: 'warning',
            customClass: { confirmButton: 'btn btn-danger' },
            buttonsStyling: false,
            heightAuto: false
          })
        })
        .finally(() => {
          this.loading_deal_uuids = this.loading_deal_uuids.filter(id => id !== uuid);
        });
    },
    addContent(content) {
      this.content_published = content.status === 'published'
      this.campaign_influencer_to_add = content.uuid
      this.show_add_content = true
      this.key_modal_add = !this.key_modal_add
      this.agreement_with_creator = content.agreement_with_creator
      this.content_by_network = content.content_by_network
    },
  },
  watch: {
    current_page() {
      if (this.view_list) {
        this.getCampaignManage();
      }
    },
    view_list(newValue) {
      if (newValue) {
        // Cambiaste a vista table
        this.checkedNames = [];
      } else {
        // Cambiaste a vista card
        this.exportable = [];
      }
    },
  }
};
</script>

<style scoped lang="scss">
.show-dropdown-views {
    display: none;
    @media (min-width: 992px) and (max-width: 1250px) {
      display: block;
    }
  }

  .hide-dropdown-views {
    @media (min-width: 992px) and (max-width: 1250px) {
      display: none;
    }
  }
  @media (max-width: 991px) {
    .w-md-100 {
      width: 100% !important;
    }
  }
  .avatar-contents-more {
    background:#0096fe
  }
  .w-avatares-table {
    width: 100px;
  }
.card-skeleton {
  background-color: #fff;
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: .4rem;
  }
  .skeleton {
    &.profile-avatar {
      width: 200px;
      height: 200px;
      border-radius: 100%;
    }
  }
}
.all-results-loaded-text {
  color: #7F7F7F;
  font-size: 0.9rem;
  padding: 1.5rem 0;
}
.vgt-table-influencers-inner-campaign {
  overflow: visible !important;
}
.vgt-table-influencers-inner-campaign tbody tr:hover {
  cursor: pointer;
  background-color: rgb(240, 240, 240) !important;
  transition: all 200ms;
}
.row-bg-selected {
  cursor: pointer;
  background-color: rgb(240, 240, 240) !important;
  transition: all 200ms;
}
  .delete-creator {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9
  }
.socialnet-campaigns {
    font-size: 1.3em;
    position: absolute;
    left: 60%;
    bottom: 0;
    background: white;
    z-index: 9;
    padding: 2%;
    border-radius: 50%;
  }
  @media(min-width:2000px) {
    .socialnet-campaigns {
      left: 55%;
    }
  }
  @media(max-width: 992px) {
    .socialnet-campaigns {
      left: 54%;
    }
  }
@import "@core/scss/vue/libs/vue-select.scss";
.body-button-center{
  position: relative;
  background-color: #e9ecef;
  padding: .25rem .25rem;
  border-radius: .375rem;

  @media (max-width: 991.98px) {
    width: 100%;
  }
}
.button-outline-header-grid-active {
  background: white;
  padding: 5px 10px;
  border-radius: 6px !important;
}

.button-outline-header-grid-no-active {
  background: transparent;
  padding: 5px 10px;
  border: none;
}
.icon-squad-network {
  width: 20px !important;
}
.vgt-table-managing {
  overflow-x: scroll;
}
.vgt-table {
  width: 100% !important;
}
.vgt-table thead {
  border-bottom: 1px solid #9eaebf !important;
}
.vgt-table th > span, .vgt-table th > div{ 
  padding-bottom: 1em;
}
.iconCheck {
  height: 18px;
}
.export-button-table {
  background-color: #f8f5fe !important;
  color: #0d1318;
  border: 1px solid #0d1318;
}
.export-button-table:disabled {
  color:  rgba(175, 175, 175, 0.8);
  border: 1px solid rgba(175, 175, 175, 0.8);
}
.name-link:hover {
  text-decoration: underline;
  cursor: pointer;
}
.name-link {
  color: black;
}
.sidebar-icon {
  font-size: 18px;
  margin-right: 10px;
}
.container-avatar-table {
  position: relative;
}
.container-avatar-table-icon {
  position: absolute; 
  bottom: -5px; 
  left: 22px;
}
.vgt-table-managing tbody tr:hover{
  cursor: pointer;
  background-color: rgb(240, 240, 240);
  transition: all 200ms;
}
.add-content-sidebar-button {
  float: right;
  margin-top: -2em;
}
.cancel-button-swat-contents {
  border: 0 !important;
  box-shadow: none !important;
}
.cancel-button-swat-contents:focus {
  border: 0 !important;
  box-shadow: none !important;
}
</style>

<style>
.complete-deal-modal-header {
  background-color: #ea5455;
}
.complete-deal-close-icon {
  display: block;
  color: white;
  margin: 0 1.3em 0 0;
  cursor: pointer;
}
.complete-deal-close-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
}
.complete-deal-warning-box {
  background-color: #fce4e4;
  border: 1px solid #ea5455;
  border-radius: 6px;
  padding: 10px 14px;
  color: #b42318;
  font-size: 0.9rem;
}
.complete-deal-info-text {
  font-size: 0.85rem;
  color: #6e6b7b;
  margin-bottom: 0;
}
</style>
